import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Download, CheckCircle } from 'lucide-react';
import BrochureDownloadModal from '../components/BrochureDownloadModal';

const DownloadBrochure = () => {
  const [brochureModalOpen, setBrochureModalOpen] = useState(false);

  const benefits = [
    "Complete product specifications and technical details",
    "6H Acrylic Laminated Boards with dimensional accuracy",
    "CNC Designer Doors, Mica, and Veneer Door collections",
    "Decorative Wall Panel systems",
    "Application examples and installation guidance",
    "Dealer and distributor information"
  ];

  return (
    <div className="min-h-screen bg-white pt-24 pb-20">
      {/* Hero Section */}
      <section className="bg-[#004534] text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Download CriLam Product Catalogue
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Explore our complete range of 6H Acrylic Laminated Boards, CNC Designer Doors, Wall Panels, and Veneer Doors
            </p>
            <Button
              onClick={() => setBrochureModalOpen(true)}
              size="lg"
              className="rounded-full bg-[#D4AF37] hover:bg-[#C19B2E] text-white font-semibold px-10 py-6 text-lg"
            >
              <Download className="h-6 w-6 mr-2" />
              Download Catalogue
            </Button>
          </div>
        </div>
      </section>

      {/* What's Inside Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-[#004534] text-center mb-12">
              What's Inside the Catalogue?
            </h2>
            
            <div className="grid md:grid-cols-2 gap-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start gap-4">
                  <CheckCircle className="h-6 w-6 text-[#D4AF37] flex-shrink-0 mt-1" />
                  <p className="text-gray-700 font-medium">{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Brochure Preview Section */}
      <section className="py-16 bg-[#FAFFEE]">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-3xl font-bold text-[#004534] text-center mb-12">
              Catalogue Preview
            </h2>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="/brochure/BROUCHER -11 page_251027_220332-01.png"
                  alt="CriLam Catalogue Cover"
                  className="w-full h-auto"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="/brochure/BROUCHER -11 page_251027_220332-02.png"
                  alt="CriLam Product Range"
                  className="w-full h-auto"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="/brochure/BROUCHER -11 page_251027_220332-03.png"
                  alt="CriLam Applications"
                  className="w-full h-auto"
                />
              </div>
            </div>

            <div className="text-center mt-12">
              <Button
                onClick={() => setBrochureModalOpen(true)}
                size="lg"
                className="rounded-full bg-[#D4AF37] hover:bg-[#C19B2E] text-white font-semibold px-10 py-6 text-lg"
              >
                <Download className="h-6 w-6 mr-2" />
                Get Complete Catalogue
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Why CriLam Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-[#004534] mb-6">
              Why Choose CriLam Decorative?
            </h2>
            <p className="text-lg text-gray-700 mb-8">
              As a Pan-India manufacturer of high-performance acrylic laminated boards and interior doors, we deliver engineered surfaces built for durability and consistent performance across residential and commercial projects.
            </p>
            <div className="grid md:grid-cols-3 gap-8 mt-12">
              <div className="text-center">
                <div className="text-4xl font-bold text-[#D4AF37] mb-2">6H</div>
                <p className="text-gray-700 font-medium">Surface Hardness</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#D4AF37] mb-2">Zero</div>
                <p className="text-gray-700 font-medium">Swelling Performance</p>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-[#D4AF37] mb-2">Pan-India</div>
                <p className="text-gray-700 font-medium">Supply Network</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Brochure Download Modal */}
      <BrochureDownloadModal
        isOpen={brochureModalOpen}
        onClose={() => setBrochureModalOpen(false)}
      />
    </div>
  );
};

export default DownloadBrochure;
